module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.person) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h1', [(_vm.person.salutation) ? _c('span', {
    staticClass: "d-none"
  }, [_vm._v(_vm._s(_vm.person.salutation) + " ")]) : _vm._e(), _vm._v(_vm._s(_vm.person.full_name)), (_vm.person.code) ? _c('span', [_vm._v(" (" + _vm._s(_vm.person.code) + ")")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'personEdit',
        params: {
          personId: _vm.person.id
        }
      },
      "target": "_blank"
    }
  }, [_c('small', {
    staticClass: "edit-icon"
  }, [_c('fa-icon', {
    attrs: {
      "icon": "edit"
    }
  })], 1)])], 1), _vm._v(" "), _c('p', [_c('small', [_vm._v(_vm._s(_vm.$t('person.registeredAt')) + " " + _vm._s(_vm._f("smallDate")(_vm.person.created_at)))])]), _vm._v(" "), _c('address', [(_vm.person.address || _vm.person.zipcode || _vm.person.city || _vm.person.country) ? _c('p', [(_vm.person.address) ? _c('span', [_vm._v(_vm._s(_vm.person.address)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.person.zipcode) ? _c('span', [_vm._v(_vm._s(_vm.person.zipcode) + " ")]) : _vm._e(), (_vm.person.city) ? _c('span', [_vm._v(_vm._s(_vm.person.city))]) : _vm._e(), (_vm.person.zipcode || _vm.person.city) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.person.country) ? _c('span', [_vm._v(_vm._s(_vm.person.country))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('p', [(_vm.person.email) ? _c('span', [_c('a', {
    attrs: {
      "href": ("mailto:" + (_vm.person.email))
    }
  }, [_vm._v(_vm._s(_vm.person.email)), _c('br')])]) : _vm._e(), _vm._v(" "), (_vm.person.telephone) ? _c('span', [_vm._v(_vm._s(((this.$t('person.telephone')) + ": "))), _c('a', {
    attrs: {
      "href": ("tel:" + (_vm.person.telephone))
    }
  }, [_vm._v(_vm._s(_vm.person.telephone))])]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.person.mobile) ? _c('span', [_vm._v(_vm._s(((this.$t('person.mobile')) + ": "))), _c('a', {
    attrs: {
      "href": ("tel:" + (_vm.person.mobile))
    }
  }, [_vm._v(_vm._s(_vm.person.mobile))])]) : _vm._e()])]), _vm._v(" "), (_vm.person.fixed_bid_number) ? _c('p', {
    staticClass: "font-italic"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.$t('person.fixedBidNumber')) + " " + _vm._s(_vm.person.fixed_bid_number) + "\n\t\t")]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4139b92"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Person/PersonInfo.vue
// module id = 1345
// module chunks = 1